import React, { useContext } from "react";
import { AppContext } from "../../../stores/application.store";
import "./ProgressBar.scss";
import { useEffect } from "react";
import { useState } from "react";
const ProgressBar = (props) => {
  const {
    pageView,
    setPageView,
    bestSinger,
    bestArtists,
    bestSongs,
    didFill,
    flickAnimation,
    setFlickAnimation,
  } = useContext(AppContext);

  const [items, setItems] = useState([]);
  const [canAccess, setCanAccess] = useState(false);

  useEffect(() => {
    setCanAccess(false);
    if (props.barType == 1) {
      setCanAccess(true);
    }
    if (props.barType == 2 && didFill.bestSongs) {
      setCanAccess(true);
    }
    if (props.barType == 3 && didFill.bestArtists && didFill.bestSongs) {
      setCanAccess(true);
    }
  }, [didFill]);

  const SetState = () => {
    if (props.barType == 1) {
      setItems([...bestSongs]);
    } else if (props.barType == 2) {
      setItems([...bestArtists]);
    } else if (props.barType == 3) {
      setItems([...bestSinger]);
    }
  };
  const Flicker = () => {
    setFlickAnimation(true);
    setTimeout(() => {
      setFlickAnimation(false);
    }, 2000);
  };
  const PressedBar = () => {
    if (pageView == props.barType) {
      return;
    }
    if (props.barType == 1) {
      setPageView(1);
    } else if (props.barType == 2 && didFill.bestSongs) {
      setPageView(2);
    } else if (props.barType == 3 && didFill.bestSongs && didFill.bestArtists) {
      setPageView(3);
    } else {
      Flicker();
    }
    return;
  };

  useEffect(() => {
    SetState();
  }, [bestSinger, bestArtists, bestSongs]);

  useEffect(() => {
    SetState();
  }, []);

  const isActive = (index) => {
    if (
      (props.barType == 1 && index > bestSongs.length) ||
      (props.barType == 2 && index > bestArtists.length) ||
      (props.barType == 3 && index > bestSinger.length)
    ) {
      return "active";
    }
    return "";
  };
  return (
    <div
      className={`progress-bar ${props.barType == pageView ? "open" : ""}
      ${canAccess ? "avaliable" : ""}`}
      onClick={() => PressedBar()}
    >
      <h4 className="bar-title">{props.title}</h4>
      <h5 className="bar-counter">{`${
        items.filter((item) => item != 0).length >= 10
          ? items.filter((item) => item != 0).length
          : `${items.filter((item) => item != 0).length}`
      }/${items.length >= 10 ? items.length : `0${items.length}`}`}</h5>
      <div
        className={`bar ${
          (didFill.bestSinger &&
            props.barType == 3 &&
            didFill.bestArtists &&
            didFill.bestSongs) ||
          (didFill.bestArtists && props.barType == 2 && didFill.bestSongs) ||
          (didFill.bestSongs && props.barType == 1)
            ? "filled"
            : ""
        }
        `}
      >
        {items.map((item, index) => {
          return (
            <div
              key={index}
              className={`selection-cube ${item != 0 ? "active" : ""} ${
                (flickAnimation && index < 5) ? "flick" : ""
              }`}
            ></div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBar;
